export default function isUnSupported() {
  if (!crypto || !crypto.randomUUID) {
    return true;
  }

  return false;
}
